// extracted by mini-css-extract-plugin
module.exports = {"container":"Links_container__DsrtS","add":"Links_add__aibG7","links":"Links_links__2Q0Am","link":"Links_link__kqVzp","input":"Links_input__18qP8"};